import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    videoId: String,
    steps: { type: Array, default: [15, 25, 35] }
  }

  static targets = ["step", "videoContainer"]

  connect() {
    this.player = null
    this.timeInterval = null
    this.loadYouTubeAPI()
  }

  disconnect() {
    this.stopTimeTracking()
    if (this.player) {
      this.player.destroy()
    }
  }

  loadYouTubeAPI() {
    if (window.YT && window.YT.Player) {
      return
    }

    if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      const script = document.createElement("script")
      script.src = "https://www.youtube.com/iframe_api"
      document.head.appendChild(script)
    }
  }

  play() {
    const container = document.createElement("div")
    container.id = `youtube-player-${this.videoIdValue}`
    container.className = "w-full h-full absolute top-0 left-0 rounded-md"

    this.videoContainerTarget.innerHTML = ""
    this.videoContainerTarget.appendChild(container)

    const initPlayer = () => {
      this.player = new YT.Player(container.id, {
        videoId: this.videoIdValue,
        playerVars: {
          autoplay: 1,
          rel: 0,
          modestbranding: 1
        },
        events: {
          onStateChange: this.onPlayerStateChange.bind(this)
        }
      })
    }

    if (window.YT && window.YT.Player) {
      initPlayer()
    } else {
      window.onYouTubeIframeAPIReady = initPlayer
    }
  }

  onPlayerStateChange(event) {
    if (event.data === YT.PlayerState.PLAYING) {
      this.startTimeTracking()
    } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
      this.stopTimeTracking()
    }
  }

  startTimeTracking() {
    this.stopTimeTracking()
    this.timeInterval = setInterval(() => {
      if (this.player && this.player.getCurrentTime) {
        const currentTime = this.player.getCurrentTime()
        this.highlightStep(currentTime)
      }
    }, 250)
  }

  stopTimeTracking() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
      this.timeInterval = null
    }
  }

  highlightStep(currentTime) {
    const steps = this.stepsValue
    let activeIndex = -1

    for (let i = steps.length - 1; i >= 0; i--) {
      if (currentTime >= steps[i]) {
        activeIndex = i
        break
      }
    }

    this.stepTargets.forEach((step, index) => {
      if (index === activeIndex) {
        step.classList.add("video-step-active")
      } else {
        step.classList.remove("video-step-active")
      }
    })
  }
}
